import { Component, Input } from '@angular/core';

/**
 * Wrapper layout for admin list pages.
 *
 * Slots:
 *   [slot=actions]  — action buttons aligned to the right of the heading
 *   [slot=filters]  — Bootstrap filter card panel (optional)
 *   default         — the <app-table> or other list content
 */
@Component({
  selector: 'app-admin-list-page',
  standalone: true,
  templateUrl: './admin-list-page.component.html',
  host: { style: 'display: block' },
})
export class AdminListPageComponent {
  @Input({ required: true }) title!: string;
}
